module.exports = __webpack_public_path__ + "assets/img/9cf0083e7f2d01ce63623c7fd8b0b76f.png";